import React from "react";
import "../../_css/Static.css";
import { notifyError } from "../helper/Toaster";
import { getCMS } from "../../requests";
import { useState, useEffect } from "react";
import { formatDateLong } from "../helper/formatters";

const About = () => {

  const [ydata, setData] = useState([]);
  const [updatedAt, setUpdatedAt] = useState("");
  const [images, setImages] = useState([]);
  const [aboutData, setAboutData] = useState([]);

  const getAbout = async () => {
    try {
      const response = await getCMS({slug: "About Us", status: 1});
      setData(response.data.content);
      setImages(response.data.images);
      setUpdatedAt(response.data.updated_at);

      
      
    } catch (error) {
      console.log(error);
      notifyError(error?.response?.data?.error || "Something went wrong");
      
    }
  }


  const createAboutData = () => {
    let data = [];
    for(let i = 0; i < ydata.length; i++){
      // fing imageUrl from images array
      const imageUrl = images.find(image => image.imageName == ydata[i]?.img)?.imageUrl;

      data.push({
        title: ydata[i].title,
        desc: ydata[i].desc,
        img: imageUrl || "",
      });
    }

    setAboutData(data);
  }

  useEffect(() => {
    getAbout();
  }, []);

  useEffect(() => {
    createAboutData();
  }, [ydata, images]);

  return (
    <div className="static-about-container">
      
      <div className="static-about-text">
        <div className="static-term-published">Published {formatDateLong(updatedAt)}</div>
      </div>

      {aboutData.length > 0 &&
        aboutData.map((e,i) => (
          <div
          key={e.title}
            className="static-about-list"
            style={{ flexDirection: `${i % 2 === 0 ? 'row' : 'row-reverse'}` }}
          >
           
            <div className="static-about-text">
              <div
                className="static-term-heading"
                style={{ textTransform: "uppercase" }}
              >
                {e.title}
              </div>
              <div className="static-term-text">{e.desc}</div>
            </div>

            {e.img && <div className="static-about-img">
               <img width='100%' height='100%' src={e.img} />
             </div>}

            
          </div>
        ))}
    </div>
  );
};

export default About;
